<template>
  <v-container class="layout--step-message">
    <transition name="fade">
      <AudienceLists
        v-show="step === 'lists'"
        ref="audienceLists"
        :step.sync="step"
        @edit="editAudience"
        @update:total="updateTotal"
      />
    </transition>
    <transition name="fade">
      <AudienceForm
        v-show="step === 'form'"
        :payload.sync="payload"
        :step.sync="step"
        @create:success="createSuccess()"
        @edit:success="editSuccess()"
        @back="gotoList()"
      />
    </transition>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import AudienceLists from './AudienceLists.vue'
import AudienceForm from './AudienceForm.vue'

export default {
  components: { AudienceLists, AudienceForm },
  data: () => ({
    step: 'lists',
    payload: {
      id: null,
      name: '',
      init_type: null,
      init_data: '',
      init_options: {
        file_name: '',
        total_completed_verify_slip: null,
        total_completed_verify_slip_more_than: null
      },
      tag_target_group_add_type: 'specific',
      tag_target_group_add_data: '',
      tag_target_group_add_add_tag: '',
      tag_target_group_add_remove_tag: '',
      tag_target_group_remove_type: 'specific',
      tag_target_group_remove_data: '',
      tag_target_group_remove_add_tag: '',
      tag_target_group_remove_remove_tag: '',
      is_allowed_broadcast: true,
      is_enabled_auto_upload_line: false,
      is_enabled_auto_upload_line_step_message: false,
      is_enabled_auto_upload_facebook: false
    },
    packages: [],
    totalAudience: 0
  }),
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    gotoList() {
      this.step = 'lists'
      this.payload.id = null
      this.payload.name = ''
      this.payload.init_type = null
      this.payload.init_data = ''
      this.payload.init_options.file_name = ''
      this.payload.tag_target_group_add_type = 'specific'
      this.payload.tag_target_group_add_data = ''
      this.payload.tag_target_group_add_add_tag = ''
      this.payload.tag_target_group_add_remove_tag = ''
      this.payload.tag_target_group_remove_type = 'specific'
      this.payload.tag_target_group_remove_data = ''
      this.payload.tag_target_group_remove_add_tag = ''
      this.payload.tag_target_group_remove_remove_tag = ''
      this.payload.is_allowed_broadcast = true
      this.payload.is_enabled_auto_upload_line = false
      this.payload.is_enabled_auto_upload_line_step_message = false
      this.payload.is_enabled_auto_upload_facebook = false
    },
    async createSuccess() {
      this.step = 'lists'
      await new Promise((resolve) => setTimeout(resolve, 500))
      if (this.$refs.audienceLists) {
        await this.$refs.audienceLists.refresh()
      }
    },
    async editSuccess() {
      this.step = 'lists'
      await new Promise((resolve) => setTimeout(resolve, 500))
      if (this.$refs.audienceLists) {
        await this.$refs.audienceLists.refresh()
      }
    },
    editAudience(audience) {
      const transformData = (arr) => {
        return arr && arr.length ? arr.join(',') : ''
      }

      this.payload.id = audience.id
      this.payload.name = audience.name
      this.payload.init_type = audience.init_type
      this.payload.init_data = transformData(audience.init_data)
      this.payload.init_options.file_name = audience.init_options.file_name
      this.payload.tag_target_group_add_type = audience.tag_target_group_add_type
      this.payload.tag_target_group_add_data = transformData(audience.tag_target_group_add_data)
      this.payload.tag_target_group_add_add_tag = transformData(
        audience.tag_target_group_add_add_tag
      )
      this.payload.tag_target_group_add_remove_tag = transformData(
        audience.tag_target_group_add_remove_tag
      )
      this.payload.tag_target_group_remove_type = audience.tag_target_group_remove_type
      this.payload.tag_target_group_remove_data = transformData(
        audience.tag_target_group_remove_data
      )
      this.payload.tag_target_group_remove_add_tag = transformData(
        audience.tag_target_group_remove_add_tag
      )
      this.payload.tag_target_group_remove_remove_tag = transformData(
        audience.tag_target_group_remove_remove_tag
      )
      this.payload.is_allowed_broadcast = audience.is_allowed_broadcast
      this.payload.is_enabled_auto_upload_line = audience.is_enabled_auto_upload_line
      this.payload.is_enabled_auto_upload_line_step_message =
        audience.is_enabled_auto_upload_line_step_message
      this.payload.is_enabled_auto_upload_facebook = audience.is_enabled_auto_upload_facebook

      this.step = 'form'
    },
    updateTotal(total) {
      this.totalAudience = total
    }
  }
}
</script>

<style scoped>
.layout--step-message {
  min-height: calc(100vh - 64px);
}
</style>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/stepmessage/AudienceMain.vue